import { DataTable } from 'primereact/datatable';
import globalSettingsStores from '../../../../../../../stores/settings-stores';
import { AbstractCourse } from '../../../../../../../api/types/settings/studies/abstract-course';
import { Column } from 'primereact/column';
import CancelButton from '../../../../../../../component/ui/buttons/cancel-button/cancel-button';
import ApproveButtons from '../../../../../../../component/ui/buttons/approve-button/approve-buttons';
import React, { useState } from 'react';
import { Major } from '../../../../../../../api/types/settings/studies/major';

export const AbstractProgramFindCourses: React.FC<{
  majors: Major[];
  onSelectedCourses: (abstractCourses: AbstractCourse[]) => void;
  onHide: () => any;
}> = ({ majors, onSelectedCourses, onHide }) => {
  const [selectedCourses, setSelectedCourses] = useState<
    AbstractCourse[] | null
  >(null);

  return (
    <div>
      <DataTable
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        value={globalSettingsStores.abstractCourses.filter(
          (item) =>
            item.majors?.length > 0 &&
            item.majors.some((courseMajor) =>
              majors.some((major) => major.id === courseMajor.id),
            ),
        )}
        selection={selectedCourses}
        onSelectionChange={(e) =>
          setSelectedCourses(e.value as AbstractCourse[])
        }
        dataKey="id"
        tableStyle={{ maxWidth: '780px', direction: 'rtl' }}
      >
        <Column
          selectionMode="multiple"
          headerStyle={{ width: '3rem' }}
        ></Column>
        <Column
          style={{ textAlign: 'right' }}
          field="courseName"
          header="שם הקורס"
        ></Column>
        <Column
          field="courseHours"
          header="שעות"
          style={{ textAlign: 'right' }}
        ></Column>
        <Column
          field="attendancePercentage"
          header="אחוז נוכחות"
          style={{ textAlign: 'right' }}
        ></Column>
      </DataTable>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'left',
          marginTop: '20px',
          paddingBottom: '10px',
          width: '100%',
        }}
      >
        <CancelButton
          onClick={() => {
            onHide();
          }}
        />

        <div style={{ width: '10px' }} />
        <ApproveButtons
          onClick={async () => {
            onSelectedCourses(selectedCourses ?? []);
          }}
        />
      </div>
    </div>
  );
};
